import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import routePaths from './nameSpace';
export const MemeberPrivateRoute = (props) => {
  const isLoggedin = useSelector((state) => state.Login.isLoggedin);
  const role = useSelector((state) => state.Login.role);
  return isLoggedin && (role === "member" || role === "admin") ? <Route {...props} /> : <Redirect to={routePaths.login} />;
};
